import { useMutation } from '@tanstack/react-query';

import { type SentEmail, searchSentEmails } from '~/services/SailthruService';

export const INFINITE_REGISTER_INTEREST_NOTIFICATION_TYPE = 'infinite_register_interest';

function getMostRecentSentEmail(sentEmails: Array<SentEmail>): SentEmail {
  return sentEmails.reduce((latest, current) =>
    new Date(current.updated_at) > new Date(latest.updated_at) ? current : latest,
  );
}

export function useViewInfiniteRegisterInterestEmail() {
  return useMutation({
    mutationFn: async (email: string): Promise<SentEmail> => {
      const normalizedEmail = email.trim().toLowerCase();
      const response = await searchSentEmails({ email: normalizedEmail, limit: 1000, offset: 0 });
      const sentEmails = response.result.filter(
        (sentEmail) => sentEmail.notification_type === INFINITE_REGISTER_INTEREST_NOTIFICATION_TYPE,
      );

      if (sentEmails.length === 0) {
        throw new Error('No register interest email found for this user.');
      }

      return getMostRecentSentEmail(sentEmails);
    },
  });
}
